module.exports = __webpack_public_path__ + "fonts/DrukCondensed-Super-Web.c77fe40.woff";